// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__2459L","active":"NavigationItem_active__29kGs"};